// eslint-disable-next-line no-shadow
export enum AspectRatio {
	SQUARE = 'square',
	LANDSCAPE = 'landscape',
	PORTRAIT = 'portrait',
	MOBILE = 'mobile',
	WIDESCREEN = 'widescreen',
	INSTA = 'insta',
	TALL = 'tall',
	WIDE = 'wide',
}
